import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Username from './components/Username';
import Submit from '../../components/Submit';
import { renderCardError } from '../../utils/cardsError';

const UsernamePasswordPage = ({
  saveUsernamePasswordForm,
  getBusinessData,
  isExisting,
  createCaseErrorMessage
}) => (
  <Form
    onSubmit={saveUsernamePasswordForm}
    initialValues={getBusinessData}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <div>
          <Content>
            {({
              usernamePasswordPageTitle = '',
              usernamePasswordContent1 = '',
              usernamePasswordContent3 = '',
              usernamePasswordContent4 = '',
              usernamePasswordContent5 = '',
              existingCustomerMessageUPS = ''
            }) => (
              <div>
                <PageHeading>{usernamePasswordPageTitle}</PageHeading>
                {!isExisting ? (
                  <StandoutTile.Guidance>
                    <p>{usernamePasswordContent1}</p>
                    <BulletList
                      items={[
                        usernamePasswordContent3,
                        usernamePasswordContent4,
                        usernamePasswordContent5
                      ]}
                    />
                  </StandoutTile.Guidance>
                ) : (
                  ''
                )}
                <Username
                  isExisting={isExisting}
                  username={getBusinessData ? getBusinessData.username : ''}
                />
                {isExisting ? <p>{existingCustomerMessageUPS}</p> : ''}
                {createCaseErrorMessage && renderCardError(createCaseErrorMessage)}
              </div>
            )}
          </Content>
          <Submit />
        </div>
      </form>
    )}
  />
);

UsernamePasswordPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveUsernamePasswordForm: PropTypes.func.isRequired
};

export default UsernamePasswordPage;
